import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getNamespacedUrl } from 'utils/route-utils';
import { getSidebarLinks } from 'links';

export const NotFoundPage = ({
  location: { pathname },
  userPermissions,
  namespace,
  email,
}) => {
  const links = userPermissions
    ? getSidebarLinks(userPermissions, namespace, email)
    : [];

  // Check if a namespace redirect is possible
  const link = links.find(({ to }) => RegExp(to).test(pathname));
  if (link && link.namespace !== namespace) {
    window.location.href = getNamespacedUrl(link.namespace, pathname);
    return;
  }

  return (
    <div>
      <h1>404 Not Found</h1>
    </div>
  );
};

NotFoundPage.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }),
  namespace: PropTypes.string,
  email: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  userPermissions: PropTypes.object,
};

const mapStateToProps = ({
  app: {
    user: { userPermissions, email },
  },
}) => ({
  userPermissions,
  email,
});

export default connect(mapStateToProps)(NotFoundPage);
